import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';
import { LinkButton } from '../../../../../common/LinkButton';
import { DENIED_BY_SANCTIONS_LINK } from './constants';

export const DeniedBySanctions = () => (
  <>
    <InlineText2 color="superblack_100">Заблокировано модератором</InlineText2>

    <LinkButton href={DENIED_BY_SANCTIONS_LINK} marginTop={8}>
      Подробнее
    </LinkButton>
  </>
);
